import { API } from "../../constAPI";

const jsonHeaders = (token) => ({
  Authorization: `token ${token}`,
  Accept: "application/json",
  "Content-type": "application/json",
});

const parseResponse = async (response) => {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const message = data?.error || data?.message || data?.errors?.join(", ") || "Request failed";
    throw new Error(message);
  }
  return data;
};

const withParams = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, value);
    }
  });
  const query = search.toString();
  return query ? `?${query}` : "";
};

export const getLeagues = (filters, token) => (
  fetch(`${API}/api/admin/leagues${withParams(filters)}`, {
    headers: jsonHeaders(token),
  }).then(parseResponse)
);

export const createLeague = (payload, token) => (
  fetch(`${API}/api/admin/leagues`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  }).then(parseResponse)
);

export const updateLeague = (id, payload, token) => (
  fetch(`${API}/api/admin/leagues/${id}`, {
    method: "PATCH",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  }).then(parseResponse)
);

export const getLeagueDetail = (id, token) => (
  fetch(`${API}/api/admin/leagues/${id}`, {
    headers: jsonHeaders(token),
  }).then(parseResponse)
);

export const publishLeagueRules = (id, payload, token) => (
  fetch(`${API}/api/admin/leagues/${id}/rules`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  }).then(parseResponse)
);

export const addLeagueMembers = (id, playerIds, token) => (
  fetch(`${API}/api/admin/leagues/${id}/members`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify({ player_ids: playerIds }),
  }).then(parseResponse)
);

export const removeLeagueMember = (id, playerId, token) => (
  fetch(`${API}/api/admin/leagues/${id}/members/${playerId}`, {
    method: "DELETE",
    headers: jsonHeaders(token),
  }).then(parseResponse)
);

export const refundLeagueEnrollment = (id, membershipId, token) => (
  fetch(`${API}/api/admin/leagues/${id}/enrollments/${membershipId}/refund`, {
    method: "POST",
    headers: jsonHeaders(token),
  }).then(parseResponse)
);

export const activateLeague = (id, token) => (
  fetch(`${API}/api/admin/leagues/${id}/activate`, {
    method: "POST",
    headers: jsonHeaders(token),
  }).then(parseResponse)
);

export const getLeagueStandings = (id, token) => (
  fetch(`${API}/api/admin/leagues/${id}/standings`, {
    headers: jsonHeaders(token),
  }).then(parseResponse)
);

export const recordLeagueResult = (leagueId, matchId, payload, token) => (
  fetch(`${API}/api/admin/leagues/${leagueId}/matches/${matchId}/result`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(payload),
  }).then(parseResponse)
);
